module.exports = __webpack_public_path__ + "img/folio-mobile.80d995c.jpg";